const Links = {
    NewInsuranceSystem: environmentURLs.NewInsuranceSystem,
    introductoryBrochureForTheNewInsuranceSystem: environmentURLs.introductoryBrochureForTheNewInsuranceSystem,
    RetirementAssistant: environmentURLs.RetirementAssistant,
    index: {
        introductionVideo: 'https://www.youtube.com/embed/3oTGFcsfGMg?si=3ksRc4mVLw8pcd1w?rel=0',
    },
    journey1: {
        "postModal-vid1-video": 'https://www.youtube.com/embed/3oTGFcsfGMg?si=3ksRc4mVLw8pcd1w?rel=0',
        "postModal-vid2-video": 'https://www.youtube.com/embed/3oTGFcsfGMg?si=3ksRc4mVLw8pcd1w?rel=0',
        "postModal-vid6-video": 'https://www.youtube.com/embed/3oTGFcsfGMg?si=3ksRc4mVLw8pcd1w?rel=0',
    },
    journey2: {
    },
    journey3: {
        "postModal-vid1-video": 'https://www.youtube.com/embed/3oTGFcsfGMg?si=3ksRc4mVLw8pcd1w?rel=0',
        "postModal-vid2-video": 'https://www.youtube.com/embed/3oTGFcsfGMg?si=3ksRc4mVLw8pcd1w?rel=0',
        "postModal-vid4-video": 'https://www.youtube.com/embed/3oTGFcsfGMg?si=3ksRc4mVLw8pcd1w?rel=0',
        "postModal-vid7-video": 'https://www.youtube.com/embed/3oTGFcsfGMg?si=3ksRc4mVLw8pcd1w?rel=0',
    },
    journey4: {
        "postModal-vid1-video": 'https://www.youtube.com/embed/3oTGFcsfGMg?si=3ksRc4mVLw8pcd1w?rel=0',
    },

}












window.youtubeIDs = [];
$(window).on('load', function () {
    // NewInsuranceSystem
    setHrefByClassNameToATag('newInsuranceSystem', Links.NewInsuranceSystem)
    setHrefByClassNameToATag('retirementAssistant', Links.RetirementAssistant)
    setHrefByClassNameToATag('introductoryBrochureForTheNewInsuranceSystem', Links.introductoryBrochureForTheNewInsuranceSystem)

    // embed YouTube Video that are on the page itself not(in a modal), for modal videos check handleVideoModalClick()
    // HomePage
    embedYouTubeVideo('introductionVideo', Links.index.introductionVideo)

    // Adding event listeners to all .videoModal elements
    document.querySelectorAll('.videoModalBtn').forEach(function (button) {
        button.addEventListener('click', handleVideoModalClick);
    });

    window.isYouTubeIframeAPIReady = false;
    window.onYouTubeIframeAPIReady = function () {
        window.isYouTubeIframeAPIReady = true;
        youtubeIDs.forEach(ID => {
            new YT.Player(ID.containerId, {
                height: '100%',
                width: '100%',
                videoId: ID.videoId,
                origin: window.location.origin, //window.location.origin,         // Set the correct origin here
                playerVars: {
                    'autoplay': 0,                      // Auto-play the video on load
                    'controls': 0,                      // 0 to hide, 1 to show controls
                    'rel': 0,                           // Show related videos from the same channel
                    'loop': 1,                          // Loop the video
                    'color': 'green',                   // Player's video progress bar color to green
                    'fs': 0,                            // Display the fullscreen button
                    'hl': 'ar'                          // Set interface language to Arabic  
                },
                events: {
                    'onReady': onPlayerReady = () => {
                        if (youtubeIDs[youtubeIDs.length - 1].containerId == ID.containerId) {
                            document.querySelectorAll('.youtubeVideoContainer').forEach(iframe => {
                                setIframeHeightByAspectRatio('16:9', iframe.id)
                            })
                            // console.log('allVideosLoaded')
                        }
                    }
                }
            });
        });
    }
    loadYoutubeIframeAPI();
})


document.addEventListener('DOMContentLoaded', function () {

 

    var myOffcanvas = document.getElementById('offcanvasDarkNavbar')

    if (myOffcanvas) {
        myOffcanvas.addEventListener('show.bs.offcanvas', function () {
            document.getElementById('share').style.display = 'none';
        })

        myOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
            document.getElementById('share').style.display = 'block';
        })

        //modal:
        document.querySelectorAll('[data-bs-toggle="modal"]').forEach(button => {
            // console.log('clicked')
            button.addEventListener('click', () => {
                document.getElementById('share').style.zIndex = '1';
            });
        })
        document.querySelectorAll('.btn-close').forEach(button => {
            button.addEventListener('click', () => {
                document.getElementById('share').style.zIndex = '9999';
            });
        })

    }


    UpdatePageContentHeight('.accordion-button');
    UpdatePageContentHeight('.icon-card');
    UpdatePageContentHeight('.checklist__item');


})


/// functions: 
// Function to handle the click event
function handleVideoModalClick(event) {
    // Extracting the data-bs-target value and removing the '#' character
    var youtubeVideoContainerId = event.currentTarget.getAttribute('data-bs-target').replace('#', '') + "-video";
    var youtubeLinkId = extractYouTubeID(Links[getPageNameFromURL()][youtubeVideoContainerId]);

    // Get the container element by its ID
    const container = document.getElementById(youtubeVideoContainerId);

    // Call youtube API using the targetId
    //console.log('Calling API with:', youtubeVideoContainerId);

    var player;
    if(isYouTubeIframeAPIReady){
        player = new YT.Player(youtubeVideoContainerId, {
            height: '100%',
            width: '100%',
            videoId: youtubeLinkId,
            origin: window.location.origin, //window.location.origin,         // Set the correct origin here
            playerVars: {
                'autoplay': 0,                      // Auto-play the video on load
                'controls': 0,                      // 0 to hide, 1 to show controls
                'rel': 0,                           // Show related videos from the same channel
                'loop': 1,                          // Loop the video
                'color': 'green',                   // Player's video progress bar color to green
                'fs': 0,                            // Display the fullscreen button
                'hl': 'ar'                          // Set interface language to Arabic  
            },
            events: {
                'onReady': onPlayerReady = () => {
                    setIframeHeightByAspectRatio('16:9', youtubeVideoContainerId)
                }
                // 'onStateChange': onPlayerStateChange
            }
        });
    }

}

function setHrefByClassNameToATag(className, url) {
    // Find all elements with the given class name
    const elements = document.querySelectorAll(`.${className}`);

    // Loop through the elements and set the href attribute
    elements.forEach(element => {
        if (element.tagName === 'A') { // Check if the element is an anchor tag
            element.href = url;
        }
    });
}

function embedYouTubeVideo(containerId, youtubeLink) {
    // Get the container element by its ID
    const container = document.getElementById(containerId);

    // If the container exists, append the iframe to it
    if (container) {

        var videoId = extractYouTubeID(youtubeLink);

        // // Create an div element
        // const youtubeDiv = document.createElement('div');
        // youtubeDiv.id = videoId;
        // container.appendChild(youtubeDiv);


        youtubeIDs.push({ containerId: containerId, videoId: videoId })


        // // Create an iframe element
        // const iframe = document.createElement('iframe');

        // // Set the attributes for the iframe
        // iframe.setAttribute('width', '100%');
        // iframe.setAttribute('height', '100%'); 
        // iframe.setAttribute('src', `${youtubeLink}`);
        // iframe.setAttribute('frameborder', '0');
        // iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        // iframe.setAttribute('allowfullscreen', true);


        // setIframeHeightByAspectRatio('16:9', containerId)

    } else {
        //console.error('Container not found for ID:', containerId);
    }
}

function loadYoutubeIframeAPI() {
    var scriptTag = document.createElement('script');
    scriptTag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
}

function setIframeHeightByAspectRatio(aspectRatio, elementId) {
    // Get the container element by ID
    var container = document.getElementById(elementId);
    if (!container) {
        console.error('Container element not found');
        return;
    }

    // // Find the first iframe within the container
    // var iframe = container.querySelector('iframe');
    // if (!iframe) {
    //     console.error('No iframe found in the container');
    //     return;
    // }

    // Split the aspect ratio into width and height
    var parts = aspectRatio.split(":");
    if (parts.length !== 2) {
        console.error('Invalid aspect ratio');
        return;
    }
    var widthRatio = parseInt(parts[0], 10);
    var heightRatio = parseInt(parts[1], 10);

    // Calculate the new height based on the iframe's current width
    var width = container.offsetWidth;
    var newHeight = (width / widthRatio) * heightRatio;

    // Set the new height of the iframe
    container.style.height = newHeight + 'px';
}

function UpdatePageContentHeight(className) {
    var ElementArray = document.querySelectorAll(className);
    ElementArray.forEach(button => {
        // console.log(button)
        button.addEventListener("click", function () {
            // console.log('update');
            setTimeout(() => {
                pageContent.update();
                //   console.log('time 1000')
            }, "500");
        });
    });
}

function extractYouTubeID(url) {
    var regExp = /^.*(youtu\.be\/|v\/|e\/|u\/\w+\/|embed\/|watch\?v=)([^#\&\?\s]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length === 11) {
        return match[2];
    } else {
        return 'Error: Invalid YouTube URL';
    }
}

// To make it accessible globally
window.extractYouTubeID = extractYouTubeID;